import { motion } from "framer-motion";

const variantMap = {
  up: { hidden: { opacity: 0, y: 32 }, show: { opacity: 1, y: 0 } },
  down: { hidden: { opacity: 0, y: -32 }, show: { opacity: 1, y: 0 } },
  left: { hidden: { opacity: 0, x: 32 }, show: { opacity: 1, x: 0 } },
  right: { hidden: { opacity: 0, x: -32 }, show: { opacity: 1, x: 0 } },
  fade: { hidden: { opacity: 0 }, show: { opacity: 1 } },
};

export const Reveal = ({
  children,
  direction = "up",
  delay = 0,
  duration = 0.7,
  className = "",
  once = true,
  amount = 0.2,
  as: Tag = "div",
  ...rest
}) => {
  const MotionTag = motion[Tag] || motion.div;
  const variants = variantMap[direction] || variantMap.up;
  return (
    <MotionTag
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once, amount }}
      variants={variants}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export const RevealWords = ({ text, className = "", delay = 0, inView = false }) => {
  const words = text.split(" ");
  const animateProps = inView
    ? { whileInView: { y: "0%" }, viewport: { once: true, amount: 0.05 } }
    : { animate: { y: "0%" } };
  return (
    <span className={className} aria-label={text}>
      {words.map((w, i) => (
        <span
          key={i}
          className="inline-block overflow-hidden align-bottom mr-[0.25em]"
          style={{ lineHeight: 0.95 }}
        >
          <motion.span
            className="inline-block"
            initial={{ y: "110%" }}
            {...animateProps}
            transition={{
              duration: 0.85,
              delay: delay + i * 0.06,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
